import { THIS_EXPR } from "@angular/compiler/src/output/output_ast";
import { eEstadoAccionHipo } from "../common/enumModel";
import { IHipoAccionModel } from "../interfaces/hipo/IHipoAccionModel";

export class HipoAccionModel implements IHipoAccionModel{
    idHipoAccion: number;
    idHipo: number;
    detalle: string;
    fechaLimite?: Date;
    fechaCierre?: Date;
    idEstado: eEstadoAccionHipo;
    estado : string; 
    index: number;  

    constructor(){
        this.idHipoAccion = 0;
        this.idHipo = 0;
        this.detalle = '';
        this.idEstado = eEstadoAccionHipo.Pendiente;
        this.estado = '';
        this.index = 0;
    }
}